import { Component, Input, OnInit } from "@angular/core";
import { BookingItemsStore } from "@fry/booking/lib/booking-items";
import { BookingOptionDoc } from "@fry/booking/lib/booking-items/booking-option";
import { InteractiveTableOptions } from "@fry/components/common/list/interactive-table/interactive-table.component";
import { ListDefaults, TableRequest, TableService } from "@fry/lib/list";
import { TableSource } from "@fry/lib/store";

@Component({
    selector: 'eas-booking-item-option-table',
    templateUrl: './booking-item-option-table.component.html',
    providers: [
        TableService,
    ],
    standalone: false
})
export class BookingItemOptionTableComponent implements OnInit {

    @Input() bookingOption!: BookingOptionDoc;

    public tableComponentOptions: InteractiveTableOptions = {
        enableColumns: true,
        enableFilters: false,
        enableExport: false,
        enableSelection: false,
        itemSingleLabel: $localize`option`,
        itemPluralLabel: $localize`options`,
    };

    constructor(
        private bookingItems: BookingItemsStore,
        private tableService: TableService,
    ) { }

    ngOnInit() {
        this.tableComponentOptions.tableTitle = $localize `Suboptions for ${this.bookingOption.title}`;
        const sourceService = this.getSourceService();
        const defaults: ListDefaults = {
            fixedSearchModel: {
                filter: {
                    bookingOption: this.bookingOption.id
                },
                sort: {},
                select: ['title', 'status', 'type', 'windowStart', 'windowEnd', 'free', 'capacity', 'count', 'view']
            },
            preserveState: true,
        }
        const bookingItemId = this.bookingOption.bookingItem._id;
        this.tableService.setupWith(sourceService, defaults, `booking-option-table-${bookingItemId}`).subscribe();
    }

    getSourceService(): TableSource {
        const bookingItemId = this.bookingOption.bookingItem._id;
        return {
            table: (params: TableRequest) => {
                return this.bookingItems.getBookableOptionTable(bookingItemId, params);
            }
        }
    }

}